import { Fragment } from 'react';
import { normalizeChatLines } from '../../utils/chatMarkdown';

// The models reach for markdown emphasis even though the chat bubble is plain
// text, so answers showed up as "**Cena → Catedral**" with the asterisks
// visible. This covers the marks that actually turn up — bold, code, list and
// heading markers — rather than pulling in a markdown parser. Line breaks are
// the bubble's job (whitespace-pre-line).
const TOKEN = /(\*\*[^*]+\*\*|__[^_]+__|`[^`]+`)/g;

export default function InlineMarkdown({ text }: { text: string }) {
  return (
    <>
      {normalizeChatLines(text).split(TOKEN).map((part, i) => {
        if (!part) return null;
        if ((part.startsWith('**') && part.endsWith('**')) || (part.startsWith('__') && part.endsWith('__'))) {
          return <strong key={i} className="font-semibold">{part.slice(2, -2)}</strong>;
        }
        if (part.startsWith('`') && part.endsWith('`')) {
          return (
            <code key={i} className="px-1 py-0.5 rounded bg-black/5 dark:bg-white/10 font-mono text-[12px]">
              {part.slice(1, -1)}
            </code>
          );
        }
        return <Fragment key={i}>{part}</Fragment>;
      })}
    </>
  );
}
